import { Wifi, WifiOff } from "lucide-react";
// import { useConnectionStatus } from "@pineseed/gui/hook/useConnectionStatus";
import { type ConnectionStatus } from "@pineseed/gui/hook/useConnectionStatus";
import { cn } from "@pineseed/gui/util";
// import { useEffect } from "react";

export function ConnectionIndicator({ connectionStatus, className }: { connectionStatus: ConnectionStatus, className?: string }) {
  const isConnected = connectionStatus.connected;
  const isRetrying = connectionStatus.isRetrying;

  // useEffect(() => {
  //   // DEBUG: Log the connection status in the component
  //   console.log(
  //     "🔌 DEBUG: ConnectionIndicator - connectionStatus:",
  //     connectionStatus,
  //   );
  //   console.log(
  //     "🔌 DEBUG: ConnectionIndicator - isConnected:",
  //     isConnected,
  //     "isRetrying:",
  //     isRetrying,
  //   );
  // }, [connectionStatus, isConnected, isRetrying]);

  return (
    <div
      className={cn("flex items-center space-x-1 text-xs", className)}
      title={
        isConnected
          ? "Connected to server"
          : isRetrying
            ? `Reconnecting... (attempt ${connectionStatus.retryCount})`
            : "Disconnected from server"
      }
    >
      {isConnected ? (
        <Wifi size={12} className="text-green-500" />
      ) : (
        <WifiOff
          size={12}
          className={
            isRetrying ? "text-yellow-500 animate-pulse" : "text-red-500"
          }
        />
      )}
      <span
        className={
          isConnected
            ? "text-green-600 dark:text-green-400"
            : isRetrying
              ? "text-yellow-600 dark:text-yellow-400"
              : "text-red-600 dark:text-red-400"
        }
      >
        {isConnected ? "Online" : isRetrying ? "Reconnecting..." : "Offline"}
      </span>
    </div>
  );
}
